import React from "react";
import { useSearchParams } from "react-router-dom";
import { MetaOSAppContext } from "../../pages/metaos/MetaOSAppContext";
import { isMetaOsHelper } from "../../utils/url";

export type ManageAccessHookResultType = {
  openDialog: () => void;
};

export const useManageAccess = (): ManageAccessHookResultType => {
  const [searchParams, setSearchParams] = useSearchParams();
  const context = React.useContext(MetaOSAppContext);

  const openDialog = React.useCallback(() => {
    if (isMetaOsHelper()) {
      const newContext = { ...context };
      newContext.manageAccessDialog = true;
      context.updateContext(newContext);
    } else {
      searchParams.set("manageAccess", "open");
      setSearchParams(searchParams);
    }
  }, [context, searchParams, setSearchParams]);

  return {
    openDialog,
  };
};
